import * as React from "react";

const SvgRaincloud = (props) => (
  <svg
    viewBox="0 0 64 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M32 0c-6.453 0-12.055 4.516-13.563 10.688-2.492.968-4.562 2.937-5.625 5.374C5.82 15.547 0 21.11 0 28c0 6.617 5.383 12 12 12h4l2-4h-6c-4.414 0-8-3.586-8-8s3.586-8 8-8c.555 0 1.117.047 1.75.188l2 .437.375-1.938c.492-2.21 2.29-3.968 4.5-4.5l1.313-.312.187-1.313C22.844 7.696 27.085 4 32 4c3.79 0 7.227 2.11 8.938 5.5l.75 1.563 1.687-.563c.938-.328 1.79-.5 2.625-.5 4.414 0 8 3.586 8 8 0 .078.008.18 0 .25-.016.133-.047.234-.063.375l-.124 1.438 1.312.562A8.022 8.022 0 0 1 60 28c0 4.414-3.586 8-8 8h-4l2 4h2c6.617 0 12-5.383 12-12 0-4.328-2.313-8.25-6-10.375C57.79 11.187 52.484 6 46 6c-.781 0-1.586.078-2.375.25C41.047 2.36 36.742 0 32 0Zm4 20s-4 5.79-4 8 1.79 4 4 4 4-1.79 4-4-4-8-4-8ZM26 30s-4 5.79-4 8 1.79 4 4 4 4-1.79 4-4-4-8-4-8Zm16 6s-4 5.79-4 8 1.79 4 4 4 4-1.79 4-4-4-8-4-8Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgRaincloud;
